(function () {
  'use strict';

  if (window.__menuAddInitialized) return;
  window.__menuAddInitialized = true;

  const SUCCESS_RESET_MS = 1200;
  const ERROR_RESET_MS = 1200;
  const HEADER_COUNT_SELECTOR = '#header_cart_total';

  function setIcon(btn, name) {
    btn.querySelectorAll('[data-menu-add-icon]').forEach(function (el) {
      el.classList.toggle('hidden', el.dataset.menuAddIcon !== name);
    });
  }

  function setLoading(btn, loading) {
    btn.disabled = loading;
    btn.classList.toggle('opacity-60', loading);
  }

  function flashError(btn) {
    btn.classList.add('ring-2', 'ring-red-500');
    setTimeout(function () {
      btn.classList.remove('ring-2', 'ring-red-500');
      setLoading(btn, false);
    }, ERROR_RESET_MS);
  }

  function flashSuccess(btn) {
    setIcon(btn, 'check');
    setTimeout(function () {
      setIcon(btn, 'plus');
      setLoading(btn, false);
    }, SUCCESS_RESET_MS);
  }

  async function refreshHeaderCount() {
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!res.ok) return;
      const cart = await res.json();
      const el = document.querySelector(HEADER_COUNT_SELECTOR);
      if (el) el.textContent = cart.item_count;
    } catch (e) {
      console.error('menu-add: failed to refresh header count', e);
    }
  }

  async function addToCart(variantId) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
    });
    if (!res.ok) {
      const body = await res.text();
      throw new Error('cart/add failed: ' + res.status + ' ' + body);
    }
    return res.json();
  }

  document.addEventListener('click', async function (event) {
    const btn = event.target.closest('[data-menu-add]');
    if (!btn || btn.disabled) return;

    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    setLoading(btn, true);

    try {
      await addToCart(variantId);
      await refreshHeaderCount();
      flashSuccess(btn);
    } catch (err) {
      console.error('menu-add:', err);
      flashError(btn);
    }
  });
})();
